import { Box, Button, Grid, Link, Modal } from "@mui/material";
import React from "react";
import AddNewRequest from "../../../../Components/Broker/Endorsment/AddNewRequest/AddNewRequest";
import UGTable from "../../../../Supporting files/UGTable/UGTable";
import { useNavigate } from "react-router-dom";
import SelectDropdown from "../../../../Supporting files/SelectDropdown/SelectDropdown";

function Endosement() {
  const [addPolicyStatus, setAddPolicyStatus] = React.useState(false);
  const [addNewRequest, setAddNewRequest] = React.useState(false);
  const [viewDocuments, setViewDocuments] = React.useState(false);
  const [priorityStatus, setPriorityStatus] = React.useState("Approved");
  const navigate = useNavigate();
  const prioritystatusData = [
    { key: "Approved", value: "Approved" },
    { key: "Rejected", value: "Rejected" },
    { key: "Pending", value: "Pending With Insurer" },
    { key: "Sent_To_Insurer", value: "Sent To Insurer" },
    { key: "Documents Pending", value: "Documents Pending" },
    { key: "Raised", value: "Raised" },
  ];

  //Table Data
  const [columns, setColumns] = React.useState([
    {
      field: "endorsement_id",
      headerName: "Endorsement ID",
      flex: 2,
      minWidth: 150,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return (
          <Link
            underline="none"
            style={{
              cursor: "pointer",
              fontWeight: "400",
              color: "#2166AA",
              textDecoration: "none",
            }}
            onClick={() => {
              navigate("/EndorsementDetailEmployer");
            }}
          >
            {row.endorsement_id}
          </Link>
        );
      },
    },
    {
      field: "client_id",
      headerName: "Client ID",
      flex: 4,
      minWidth: 150,
      check_status: true,
    },
    {
      field: "client_name",
      headerName: "Client Name",
      flex: 8,
      minWidth: 150,
      check_status: true,
    },
    {
      field: "employee_id",
      headerName: "Member ID",
      flex: 3,
      minWidth: 200,
      check_status: true,
    },
    {
      field: "employee_name",
      headerName: "Member Name",
      flex: 1,
      minWidth: 200,
      check_status: true,
    },
    {
      field: "policy",
      headerName: "Policy Number",
      flex: 1,
      minWidth: 150,
      check_status: true,
    },

    {
      field: "type",
      headerName: "Policy Type",
      flex: 1,
      minWidth: 200,
      check_status: true,
    },
    {
      field: "endorsementvalue",
      headerName: "Endorsement Value",
      flex: 1,
      minWidth: 150,
      check_status: true,
    },
    {
      field: "oldvalue",
      headerName: "Old Value",
      flex: 1,
      minWidth: 150,
      check_status: true,
    },
    {
      field: "newvalue",
      headerName: "New Value",
      flex: 1,
      minWidth: 150,
      check_status: true,
    },
    {
      field: "insurer",
      headerName: "Insurer",
      flex: 2,
      minWidth: 150,
      check_status: true,
    },
    {
      field: "status",
      headerName: "Status",
      flex: 2,
      minWidth: 200,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return (
          <div id={priorityStatus}>
            <div className="status_dropdown" id={priorityStatus}>
              <SelectDropdown
                class_name="inputFieldd"
                title=""
                value={priorityStatus}
                attrName={setPriorityStatus}
                value_update={updateMasterState}
                dropdown_data={prioritystatusData}
                warn_status={false}
              />
            </div>
          </div>
        );
      },
    },
    {
      field: "supportingdocuments",
      headerName: "Supporting Documents",
      flex: 2,
      minWidth: 150,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return (
          <Link
            sx={{ textDecoration: "none" }}
            onClick={() => {
              setViewDocuments(true);
            }}
          >
            <span
              style={{
                color: "#000000",
                textDecoration: "none",
                marginRight: "10px",
              }}
            >
              {row.supportingdocuments}
            </span>
            <img
              src="images/visibility-icon.svg"
              alt=""
              style={{ zIndex: 99, position: "relative", cursor: "pointer" }}
            />
          </Link>
        );
      },
    },
  ]);
  const rows = [
    {
      id: 0,
      endorsement_id: "END2342",
      client_id: "EV2343",
      client_name: "Evervent",
      employee_id: "EMP001",
      employee_name: "Umesh Gemini",
      policy: "PB349",
      type: "Group Health",
      endorsementvalue: "Personal Address",
      oldvalue: "Vikass",
      newvalue: "Vikas",
      supportingdocuments: 4,
      status: "Raised",
      insurer: "Reliance",
    },
    {
      id: 1,
      endorsement_id: "END2344",
      client_id: "EV2343",
      client_name: "Evervent",
      employee_id: "EMP002",
      employee_name: "Vikas Saini",
      policy: "PB349",
      type: "Group Health",
      endorsementvalue: "Member Addition",
      oldvalue: "",
      newvalue: "",
      supportingdocuments: 2,
      status: "Raised",
      insurer: "Reliance",
    },
    {
      id: 2,
      endorsement_id: "END2342",
      client_id: "EV2343",
      client_name: "Evervent",
      employee_id: "EMP001",
      employee_name: "Umesh Gemini",
      policy: "PB349",
      type: "Group Health",
      endorsementvalue: "Name",
      oldvalue: "Vikass",
      newvalue: "Vikas",
      supportingdocuments: 1,
      status: "Raised",
      insurer: "Reliance",
    },
    {
      id: 3,
      endorsement_id: "END2342",
      client_id: "EV2343",
      client_name: "Evervent",
      employee_id: "EMP001",
      employee_name: "Umesh Gemini",
      policy: "PB349",
      type: "Group Health",
      endorsementvalue: "Contact",
      oldvalue: "9862145321",
      newvalue: "9874563214",
      supportingdocuments: 5,
      status: "Raised",
      insurer: "Reliance",
    },
    {
      id: 4,
      endorsement_id: "END2342",
      client_id: "EV2343",
      client_name: "Evervent",
      employee_id: "EMP001",
      employee_name: "Umesh Gemini",
      policy: "PB349",
      type: "Group Health",
      endorsementvalue: "Name",
      oldvalue: "Vikass",
      newvalue: "Vikas",
      supportingdocuments: 3,
      status: "Raised",
      insurer: "Reliance",
    },
    {
      id: 5,
      endorsement_id: "END2342",
      client_id: "EV2343",
      client_name: "Evervent",
      employee_id: "EMP001",
      employee_name: "Umesh Gemini",
      policy: "PB349",
      type: "Group Health",
      endorsementvalue: "Contact",
      oldvalue: "9862145321",
      newvalue: "9874563214",
      supportingdocuments: 5,
      status: "Raised",
      insurer: "Reliance",
    },
    {
      id: 6,
      endorsement_id: "END2342",
      client_id: "EV2343",
      client_name: "Evervent",
      employee_id: "EMP001",
      employee_name: "Umesh Gemini",
      policy: "PB349",
      type: "Group Health",
      endorsementvalue: "Name",
      oldvalue: "Vikass",
      newvalue: "Vikas",
      supportingdocuments: 2,
      status: "Raised",
      insurer: "Reliance",
    },
    {
      id: 7,
      endorsement_id: "END2342",
      client_id: "EV2343",
      client_name: "Evervent",
      employee_id: "EMP001",
      employee_name: "Umesh Gemini",
      policy: "PB349",
      type: "Group Health",
      endorsementvalue: "Contact",
      oldvalue: "9862145321",
      newvalue: "9874563214",
      supportingdocuments: 3,
      status: "Raised",
      insurer: "Reliance",
    },
    {
      id: 8,
      endorsement_id: "END2342",
      client_id: "EV2343",
      client_name: "Evervent",
      employee_id: "EMP001",
      employee_name: "Umesh Gemini",
      policy: "PB349",
      type: "Group Health",
      endorsementvalue: "Name",
      oldvalue: "Vikass",
      newvalue: "Vikas",
      supportingdocuments: 1,
      status: "Raised",
      insurer: "Reliance",
    },
    {
      id: 9,
      endorsement_id: "END2342",
      client_id: "EV2343",
      client_name: "Evervent",
      employee_id: "EMP001",
      employee_name: "Umesh Gemini",
      policy: "PB349",
      type: "Group Health",
      endorsementvalue: "Contact",
      oldvalue: "9862145321",
      newvalue: "9874563214",
      supportingdocuments: 2,
      status: "Raised",
      insurer: "Reliance",
    },
  ];
  const updateMasterState = (attrName: any, value: string) => {
    attrName(value);
  };

  return (
    <Grid container spacing={3} className="claimAssistant">
      <Modal open={addPolicyStatus} className="modalWrapper">
        <Box className="modalInner">
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Link
                className="close-button"
                onClick={() => {
                  setAddPolicyStatus(false);
                }}
              />
              <h5 className="popup-heading">Uploading file</h5>
            </Grid>
          </Grid>
          <Grid container spacing={0}>
            <Grid item xs={12} className="mb-5">
              <Link className="md-link" underline="none">
                67%... donot close or switch tab while it’s uploading
              </Link>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid
              item
              xs={12}
              className="ctaBtn"
              style={{ textAlign: "center" }}
            >
              <Button variant="contained" className="submitBtn">
                Upload
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
      <Grid item xs={6}>
        <h3 className="mb-0">Endorsement</h3>
      </Grid>
      <Grid item xs={6} className="text-right">
        <Link
          underline="none"
          className="blueBtn addfile"
          onClick={() => {
            setAddNewRequest(true);
          }}
        >
          Raise New Request
        </Link>
        <AddNewRequest
          attrName={setAddNewRequest}
          open_status={addNewRequest}
          value_update={updateMasterState}
        />
      </Grid>
      <Grid item xs={12}>
        <UGTable
          header_data={columns}
          data={rows}
          value_update={updateMasterState}
          attrName={"UGTable"}
        />
      </Grid>
    </Grid>
  );
}

export default Endosement;
